import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Permissions } from "../../../utils/permissions";
import "./styles/ModernHeader.css";

const HeaderComponent = ({
  path,
  pathname,
  cerrarSesion,
  usuario,
  notificaciones,
  Quitarnotificacion,
  onClickNotificacion,
  personas,
  search,
  onChange,
  onClick,
  onToggleSidebar,
}) => {
  return (
    <div className="modern-header-content">
      {/* Sidebar Toggle Button */}
      <button
        className="sidebar-toggle-btn"
        onClick={onToggleSidebar}
        type="button"
        title="Toggle Sidebar"
      >
        <i className="bi bi-list"></i>
      </button>

      {/* Left Section - Navigation */}
      <nav className="header-nav">
        {path.map((p, index) => {
          if (p.dropdown && !Permissions(usuario.rol, p.path)) {
            return (
              <div key={index} className="header-dropdown dropdown">
                <button
                  className="header-dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="header-nav-icon" dangerouslySetInnerHTML={{ __html: p.icon }}></span>
                  {p.title}
                  <i className="bi bi-chevron-down header-dropdown-arrow"></i>
                </button>
                <ul className="dropdown-menu">
                  {p.nav_dropdown.map((n, index) => (
                    <li key={index}>
                      <a className="dropdown-item" href={n.path}>
                        {n.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            );
          }

          if (!Permissions(usuario.rol, p.path)) {
            return (
              <div key={index} className="header-nav-item">
                <a
                  className={pathname == p.path ? "header-nav-link active" : "header-nav-link"}
                  href={p.path}
                >
                  <span className="header-nav-icon" dangerouslySetInnerHTML={{ __html: p.icon }}></span>
                  {p.title}
                </a>
              </div>
            );
          }
        })}
      </nav>

      {/* Search Section */}
      <div className="header-search">
        <i className="bi bi-search header-search-icon"></i>
        <input
          type="text"
          className="header-search-input"
          placeholder="Busca por el nombre de cliente..."
          autoComplete="off"
          name="buscar"
          onChange={(event) => onChange(event)}
        />

        {search.buscar.trim() !== "" && personas.length > 0 && (
          <div className="header-search-results">
            {personas.map((persona) => (
              <div key={persona.id} className="header-search-result-item">
                <div className="header-search-result-name">
                  {persona.apellido + ", " + persona.nombre}
                </div>
                <div className="header-search-result-dni">
                  DNI: {persona.nro_documento}
                </div>
                <div className="header-search-result-actions">
                  <a
                    className="header-search-result-action"
                    href={`/clientes/ver/${persona.id}`}
                  >
                    <i className="bi bi-person"></i>
                    Ver perfil
                  </a>
                  <a
                    className="header-search-result-action"
                    href={`/creditos/${persona.id}`}
                  >
                    <i className="bi bi-credit-card"></i>
                    Ver créditos
                  </a>
                  <a
                    className="header-search-result-action"
                    href={`/gestion-mora/reportes-atrasos/editar/${persona.id}`}
                  >
                    <i className="bi bi-folder"></i>
                    Ver procesos
                  </a>
                  <a
                    className="header-search-result-action"
                    href={`/gestion-mora/calendario/${persona.id}`}
                  >
                    <i className="bi bi-calendar"></i>
                    Calendario
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Right Section - User Actions */}
      <div className="header-actions">
        <div className="header-role-badge">{usuario.rol}</div>

        {/* Notifications */}
        <div className="dropdown">
          <button
            className="header-notification-btn"
            data-bs-toggle="dropdown"
            type="button"
            aria-expanded="false"
          >
            <i className="bi bi-bell header-notification-icon"></i>
            {notificaciones && notificaciones.length > 0 && (
              <span className="header-notification-badge">{notificaciones.length}</span>
            )}
          </button>
          <div className="dropdown-menu header-notification-dropdown">
            <div className="header-notification-header">Notificaciones</div>
            <div className="header-notification-list">
              {notificaciones && notificaciones.length > 0 ? (
                notificaciones.map((item) => (
                  <div
                    key={item.id}
                    className="header-notification-item"
                    onClick={() => onClickNotificacion(item)}
                  >
                    <div className="header-notification-message">{item.mensaje}</div>
                    <div className="header-notification-body">{item.body}</div>
                    <div className="header-notification-time">Creado: {item.created}</div>
                  </div>
                ))
              ) : (
                <div className="header-notification-item">
                  <div className="header-notification-message">No hay notificaciones</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* User Profile */}
        <div className="dropdown">
          <button
            className="header-profile-btn"
            data-bs-toggle="dropdown"
            type="button"
            aria-expanded="false"
          >
            <i className="bi bi-person-fill header-profile-icon"></i>
          </button>
          <div className="dropdown-menu header-profile-dropdown">
            <div className="header-profile-info">
              <div className="header-profile-avatar">
                <i className="bi bi-person-fill" style={{ fontSize: "28px" }}></i>
              </div>
              <div className="header-profile-name">{usuario.nombre}</div>
              <div className="header-profile-role">{usuario.rol}</div>
            </div>
            <div className="header-profile-menu">
              <a
                className="header-profile-menu-item"
                href="/perfil"
              >
                <i className="bi bi-person header-profile-menu-icon"></i>
                Mi Perfil
              </a>
              <div
                className="header-profile-menu-item"
                onClick={() => {
                  cerrarSesion();
                  window.location.href = "/";
                }}
              >
                <i className="bi bi-power header-profile-menu-icon"></i>
                Cerrar Sesión
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
